// tslint:disable:only-arrow-functions
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createSquarePanelFromRecommendationsProductsOnTheWay } from '../common/products-on-the-way/square-panel-products-on-the-way';

export const squarePanelFromRecommendationsProductsOnTheWay =
  mergeMultipleConfigs(
    createSquarePanelFromRecommendationsProductsOnTheWay().styleWrapper,
    [
      {
        id: 'square-panel-root',
        data: {
          brandId: {
            values: [
              {
                provider: 'GlobalStoreProviderService',
                property: {
                  path: 'session.siteId',
                },
              },
              {
                provider: 'GlobalStoreProviderService',
                property: {
                  path: 'accounts.activeAccount.sites',
                },
              },
            ],
            transform: function ([siteId, sites]: [
              string,
              { siteId: string; brandId: string }[],
            ]) {
              return sites.find((site) => site.siteId === siteId)?.brandId;
            }.toString(),
          },
        },
      },
    ],
  );
